import React, { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import Auth from './components/Auth';
import './App.less';
import { ConfigProvider } from 'antd';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

const App = () => {
  const [theme, setTheme] = useState<any>({
    themename: 'default',
    primarycolor: '#243782',
    primarycolorlight: '#146e63',
    secondarycolor: '#f6bd60',
    bordercolor: '#daf0ee',
    textcolor: '#FFF',
    linkcolor: '#00A896',
    logo: 'utinaPlatformLogo.png',
    fontface: '',
  });

  useEffect(() => {
    let them =
      localStorage?.getItem('theme') === 'undefined' ||
        localStorage?.getItem('theme') == null
        ? JSON.stringify(theme)
        : localStorage?.getItem('theme') ?? '{}';
    const newTheme = JSON?.parse(them);
    // document.documentElement.style.setProperty(`--primary-color`, newTheme?.primarycolor ?? '#00925b');
    document.documentElement.style.setProperty(`--primary-color`, '#DD7248');

    document.documentElement.style.setProperty(`--primary-color-light`, newTheme?.primarycolorlight ?? '#146e63');
    // document.documentElement.style.setProperty(`--secondary-color`, newTheme?.secondarycolor ?? '#f6bd60'); 
    document.documentElement.style.setProperty(`--secondary-color`, '#243784');

    document.documentElement.style.setProperty(`--border-color`, newTheme?.bordercolor ?? '#daf0ee');
    document.documentElement.style.setProperty(`--text-color`, newTheme?.textcolor ?? '#37474f');
    document.documentElement.style.setProperty(`--link-color`, newTheme?.linkcolor ?? '#00925b');

    setTheme({
      themename: '',
      primarycolor: newTheme?.primarycolor ?? '#00925b',
      primarycolorlight: newTheme?.primarycolorlight ?? '#146e63',
      secondarycolor: newTheme?.secondarycolor ?? '#f6bd60',
      bordercolor: newTheme?.bordercolor ?? '#daf0ee',
      textcolor: newTheme?.textcolor ?? '#37474f',
      linkcolor: newTheme?.linkcolor ?? '#00925b',
      fontface: '',
    });
  }, [localStorage.getItem('theme')]);

  return (
    <ConfigProvider
      theme={{
        cssVar: true,
        token: {
          fontFamily: 'Encode Sans Semi Expanded , serif',
          colorPrimary: theme?.primarycolor,
          // colorText: theme?.primarycolor,
          colorPrimaryActive: theme?.primarycolor,
          colorLink: theme?.primarycolor,
          borderRadius: 10,
          colorBorder: theme?.bordercolor,
          colorTextDisabled: 'black'

        },
        components: {
          Button: {
            colorPrimary: theme?.primarycolor,
            algorithm: true, // Enable algorithm
          },
          Input: { colorBorder: theme?.bordercolor, algorithm: true, },
          Collapse: {
            colorBorderBg: theme?.bordercolor,
            colorBorder: theme?.bordercolor,
            colorBorderSecondary: theme?.bordercolor,
            colorBgContainer: theme?.bordercolor,
            algorithm: true,
          },

          Tabs: {
            // cardBg: theme?.primarycolor,
            itemSelectedColor: theme?.primarycolor,
            itemActiveColor: theme?.primarycolor,
            itemColor: 'black',
            colorBorder: theme?.primarycolor,
            cardGutter: 5,
            horizontalItemMargin: '1px',
            horizontalItemGutter: 5,
            horizontalMargin: '0',
            horizontalItemPadding: '5px',
            colorBorderBg: theme?.bordercolor,
            colorBorderSecondary: theme?.bordercolor,
            controlItemBgActive: 'red',
          },
          // Table: {
          //   // borderColor: theme?.bordercolor,
          //   headerBg: theme?.bordercolor,
          // },
        },
      }}
    >
      <QueryClientProvider client={queryClient}>
        {/* <GlobalStyle /> */}
        <Auth />
      </QueryClientProvider>

    </ConfigProvider>

  );
};

export default App;
